// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__2LnwC","error":"styles_error__2iwDe","warning":"styles_warning__3x0Zo","success":"styles_success__1oVby","fixed":"styles_fixed__3i-ht"};